export default function SicboRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>

            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Sic Bo</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">Sic Bo is an exciting game of chance played with three regular dice with face value 1 to 6. The objective of Sic Bo is to predict the outcome of the shake of the three dice.</p>
                                        </div>
                                        <div>
                                            <h3><b>Betting Instructions</b></h3>
                                            <p class="pt20">If a game round is in progress when you enter the game, please wait for the next one, and then, place your bets.</p>
                                            <p class="pt20">After the timer reaches 0, the game round begins.</p>

                                            <p class="pt20">To place a bet, click on the box, enter the stake amount and submit by clicking on Place Bet button.</p>
                                            <p class="pt20">You can place several bets on different runners in different markets simultaneously.</p>
                                            <p class="pt20">The timer shows how much time you have left to place your bets.</p>
                                            <p class="pt20">Winnings are paid for the winning bets at the end of each game round.</p>
                                            <p class="pt20">To skip a turn, simply do not place any bets.</p>
                                        </div>
                                        <div>
                                            <h3><b>Main Bets</b></h3>
                                            <p class="pt20">Odd (Lose if any Triple): Predict if the Dice Total value will be odd.</p>
                                            <p class="pt20">Even (Lose if any Triple): Predict if the Dice Total value will be even.</p>
                                        </div>

                                        <div>
                                            <h3><b>Side Bets</b></h3>
                                            <p class="pt20">Small (Lose if any Triple): Predict if the Dice Total value will be in between 4 to 10.</p>
                                            <p class="pt20">Big (Lose if any Triple): Predict if the Dice Total value will be in between 11 to 17.</p>
                                            <p class="pt20">Small/Big bets lose to <strong>Any Tripple</strong>.</p>
                                            <p class="pt20">Any Triple: Predict if all three dice will have same value.</p>
                                            <p class="pt20">Triple: Predict if all three dice will have same specific value.</p>
                                            <p class="pt20">All Dice Total: Predict what will be the total value of the three dices.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20">Game round starts when Betting Timer reaches 0.</p>
                                            <p class="pt20">After betting time has expired, the dice are shaken in a dice shaker.</p>
                                            <p class="pt20">The Dealer reveals the result and game round is over.</p>
                                        </div>

                                        <div>
                                            <div>
                                                <center><h3>PAYOUTS</h3></center>
                                                <div>
                                                    <p class="pt20">Payout depends on the type of bet placed. </p>
                                                    <table class="table table-bordered table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th>4</th>
                                                                <th>1: 29</th>
                                                            </tr>
                                                            <tr>
                                                                <th>5</th>
                                                                <th>1: 19</th>
                                                            </tr>
                                                            <tr>
                                                                <th>6</th>
                                                                <th>1: 15</th>
                                                            </tr>
                                                            <tr>
                                                                <th>
                                                                    <b>7</b>
                                                                </th>
                                                                <th>1: 12</th>
                                                            </tr>
                                                            <tr>
                                                                <th>8</th>
                                                                <th>1: 8</th>
                                                            </tr>
                                                            <tr>
                                                                <th>9</th>
                                                                <th>1: 6</th>
                                                            </tr>
                                                            <tr>
                                                                <th>10</th>
                                                                <th>1: 6</th>
                                                            </tr>
                                                            <tr>
                                                                <th>11</th>
                                                                <th>1: 6</th>
                                                            </tr>
                                                            <tr>
                                                                <th>12</th>
                                                                <th>1: 6</th>
                                                            </tr>
                                                            <tr>
                                                                <th>13</th>
                                                                <th>1: 8</th>
                                                            </tr>
                                                            <tr>
                                                                <th>14</th>
                                                                <th>1: 12</th>
                                                            </tr>
                                                            <tr>
                                                                <th>15</th>
                                                                <th>1: 15</th>
                                                            </tr>
                                                            <tr>
                                                                <th>16</th>
                                                                <th>1: 19</th>
                                                            </tr>
                                                            <tr>
                                                                <th>17</th>
                                                                <th>1: 29</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Odd</th>
                                                                <th>1: 0.98</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Even</th>
                                                                <th>1: 0.98</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Small</th>
                                                                <th>1: 0.98</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Big</th>
                                                                <th>1: 0.98</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Any Triple</th>
                                                                <th>1: 19</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Triple</th>
                                                                <th> 1: 79</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <p class="pt20">Please note that any malfunction voids the game round and all eventual payouts for the round. Bets will be returned.</p>
                                                </div>
                                            </div>

                                        </div>



                                    </center>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}